document.addEventListener('DOMContentLoaded', () => {
  const formItemEls = document.querySelectorAll('.Form__Item')
  console.log(formItemEls)
  formItemEls.length && formItemEls.forEach(formItemEl => {
    const formInputEl = formItemEl.querySelector('.Form__Input')
    const formMessageEl = formItemEl.querySelector('.Form__InputMessage')
    const showError = (message = '') => {
      if (!message || !formMessageEl) return
      formMessageEl.innerHTML = message
      formItemEl.classList.add('has-error')
    }
    const reset = () => {
      if (formMessageEl) formMessageEl.innerHTML = ''
      formItemEl.classList.remove('has-error')
    }
    const validate = () => {
      formInputEl.classList.add('validated')
      reset()
      const value = formInputEl.value
      const type = formInputEl.type
      const isRequired = formInputEl.required
      if (!value) {
        if (isRequired) {
          showError('This field is required')
        }
      } else {
        if (type === 'email' && /\S+@\S+\.\S+/.test(formInputEl.value) === false) {
          showError('Please input a valid email')
        }
      }
    }
    formInputEl && formInputEl.addEventListener('blur', () => {
      validate()
    })
    formInputEl && formInputEl.addEventListener('input', () => {
      if (formItemEl.classList.contains('has-error')) {
        validate()
      }
    })
  })
})
